import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CounsellingLinksComponent } from './counselling-links/counselling-links.component';
import { CounsellingLandingpageComponent } from './counselling-landingpage/counselling-landingpage.component';

const routes: Routes = [  {
  path:'',component:CounsellingLinksComponent,
  children:[
    {
      path:"counselling", component:CounsellingLandingpageComponent

    },
    
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CounsellingRoutingModule { }
